export default "__VITE_ASSET__Ci8pnv_V__"